import { createContext, useContext } from 'react';

import type maplibregl from 'maplibre-gl';

const MapContext = createContext<maplibregl.Map | null>(null);

export const MapProvider = MapContext.Provider;

export function useMap(): maplibregl.Map {
  const map = useContext(MapContext);
  if (!map) throw new Error('useMap must be called inside a HuntMap');
  return map;
}
